import { atom } from 'jotai';

export interface LandxmlExportTracker {
  toastId: string | number;
  batchId: string;
  projectId: string;
  sourceLayerId: string;
  sourceLayerName: string;
  /**
   * How many MODEL/LANDXML layers this batch will produce — one per export
   * group, 1 for an ungrouped export. The progress hook must wait for ALL of
   * them: it matches layers on `metadata.batchId`, and every job in a grouped
   * batch stamps the same one, so resolving on the first match would report
   * success while eight more courses were still tessellating.
   */
  expectedLayers: number;
}

export const landxmlExportTrackingAtom = atom<LandxmlExportTracker[]>([]);
